module.exports = new __parcel__URL__("whatsapp.5b27f831.svg").toString();